module.exports = __webpack_public_path__ + "img/face-smile-horns.7ca0201f.svg";